import { createRootRouteWithContext } from '@tanstack/react-router'

import { ErrorPage } from '@/pages/error'
import { NotFoundPage } from '@/pages/not-found-page'

import { RootLayout } from '@/app/layouts'

export const Route = createRootRouteWithContext()({
    component: RootLayout,
    notFoundComponent: NotFoundPage,
    errorComponent: ({ error }) => (
        <ErrorPage
            description={'Страница ошибки маршрутизации'}
            error={error instanceof Error ? error.message : String(error)}
            title={'Страница ошибки маршрутизации'}
        />
    ),
})
